interface MovieCardProps {
  id: number;
  title: string;
  poster: string;
  rating: number;
  year: number;
  category: string;
  tags: string[];
  slug: string;
}

export default function MovieCard({ title, poster, rating, year, category, tags }: MovieCardProps) {
  return (
    <div className="group cursor-pointer">
      <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-200 mb-3">
        <img
          src={poster}
          alt={title}
          title={`${title} - 555电影高清免费在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md">
          {rating}
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <div className="flex flex-wrap gap-1">
            {tags.slice(0, 3).map((tag) => (
              <span key={tag} className="text-xs bg-background-50/90 text-foreground-800 px-2 py-0.5 rounded-full">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
        {title}
      </h3>
      <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
        <span>{year}</span>
        <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
        <span>{category}</span>
      </div>
    </div>
  );
}